var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.text || _vm.loading
    ? _c(
        "div",
        { class: ["ui-badge", _vm.size], style: _vm.containerStyle },
        [
          _vm.loading
            ? _c("ui-loader", { attrs: { size: "14", stroke: "6" } })
            : [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")],
          _vm.hasFade
            ? _c("div", { staticClass: "fade", style: _vm.fadeBackground })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }